import type { RootState } from '@app/types';

const MIN_PASSWORD_LENGTH = 6;

export const getSubmitting = ({ advancedSecurity }: RootState) => advancedSecurity.submitting;
export const getErrorMessage = ({ advancedSecurity }: RootState) => advancedSecurity.errorMessage;
export const getSpCertificate = ({ advancedSecurity }: RootState) => advancedSecurity.spCertificate;
export const getFormData = ({ advancedSecurity }: RootState) => advancedSecurity.data;
export const getSubmitIsDisabled = ({ advancedSecurity: { data } }: RootState) =>
    (data.passHistoryEnabled && !data.passHistoryValue) ||
    (data.passExpireEnabled && !data.passExpireValue) ||
    (data.passLengthEnabled && (!data.passLengthValue || parseInt(data.passLengthValue, 10) < MIN_PASSWORD_LENGTH)) ||
    (data.passComplexityEnabled && !data.passComplexityValue?.length);
